import { useComuniEnabled } from '@/features/comuni/useComuniFlag';
import { COMUNI_TABS_ITEM } from '@/features/comuni/comuni-helper';
import RouteConstants from '@/features/router/RouteConstants';
import { CampaignIcon, IconButton } from '@/lib';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { LuArrowRight } from 'react-icons/lu';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

type HomeContentSectionProps = {
  className?: string;
};

export const HomeContentSection: FC<HomeContentSectionProps> = ({ className }) => {
  const comuniEnabled = useComuniEnabled();
  const { t } = useTranslation();
  const titleKey = comuniEnabled ? 'home:comuniTitle' : 'home:title';
  const descriptionKey = comuniEnabled ? 'home:comuniDescription' : 'home:description';

  return (
    <div className={twMerge('flex flex-col gap-6 pt-12', className)}>
      <div className='space-y-4'>
        <h1 className='text-6xl font-bold tracking-tight text-quaternary-900'>
          <Trans
            i18nKey={titleKey}
            components={{
              br: <br />,
              blueWord: <span className='text-brand-600'></span>,
            }}
          />
        </h1>
      </div>

      <p className='text-2xl text-quaternary-700'>
        <Trans
          i18nKey={descriptionKey}
          components={{
            br: <br />,
            blueWord: <span className='font-semibold text-brand-600'></span>,
          }}
        />
      </p>
      {comuniEnabled ? (
        <div className='flex flex-wrap items-center gap-5'>
          <Link to={`${RouteConstants.comuni}?tab=${COMUNI_TABS_ITEM.NEW_COMMUNICATION}`}>
            <IconButton size='xl' text={t('home:sendMessage')} leadingIcon={<CampaignIcon className='size-5' />} />
          </Link>
          <Link to={RouteConstants.campaigns}>
            <IconButton intent='link-color' size='xl' text={t('home:seeLatestSent')} trailingIcon={<LuArrowRight className='size-5' />} />
          </Link>
        </div>
      ) : null}
    </div>
  );
};
